import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Mark, SectionLead, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-blush-50 px-4 py-12 md:py-16" data-id="element-246" data-mp="3fyvxs9ef7bak">
      <div className="mx-auto max-w-6xl" data-id="element-247" data-mp="3fxb2uio71qc6">
        <SectionTitle data-id="element-248" data-mp="3b1cj58dt8wi3">
          What our crochet <Mark data-id="element-249" data-mp="3b0ayqdawmxnp">customers are saying</Mark>
        </SectionTitle>
        <SectionLead data-id="element-250" data-mp="3700qsv3jxx67">Real projects. Real experiences.</SectionLead>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-6" data-id="element-251" data-mp="32060asnov9lo">
          {testimonials.map((item, index) => <figure key={item.name} className={`flex flex-col rounded-2xl border border-berry-600/15 bg-white p-6 shadow-sm lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-252" data-mp="2x005x4q1b8zw" data-mpi={index}>
              <div className="flex items-center justify-between gap-3" data-id="element-253" data-mp="v85b00rzzj4d">
                <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-254" data-mp="qa3pl973n7pq">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-255" data-mp="h818trjkkmm2" data-mpi={i} />)}
                </div>
              </div>
              <p className="mt-3 text-[11px] font-black uppercase tracking-wider text-berry-700" data-id="element-256" data-mp="7926srtb7p81">{item.topic}</p>
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-plum-950" data-id="element-257" data-mp="c7df2y3yhro5">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-berry-600/10 pt-4" data-id="element-258" data-mp="zyivpfhq0nzi">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-berry-600 text-xs font-black text-white" data-id="element-259" data-mp="14xluii73xxz1">
                  {item.initials}
                </span>
                <span data-id="element-260" data-mp="v3mv3qyf4sas">
                  <span className="block text-sm font-extrabold uppercase text-plum-950" data-id="element-261" data-mp="1ivk2n5uu4y63">{item.name}</span>
                  <span className="block text-xs text-muted" data-id="element-262" data-mp="1nmk14fjlroap">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-muted" data-id="element-263" data-mp="1xfmtt5udgrt7">Individual results may vary.</p>
      </div>
    </section>;
}